import { apiErrorCode } from "./sheets-failure";

export type SheetsReconnectKind = "google_reconnect_required" | "google_file_access_lost";

export type SheetsReconnectInfo = {
  kind: SheetsReconnectKind;
  title: string;
  body: string;
  action: string;
};

const COPY: Record<SheetsReconnectKind, Omit<SheetsReconnectInfo, "kind">> = {
  google_reconnect_required: {
    title: "Reconnect Google",
    body: "Google removed the OnlyDash access. Reconnect to read and edit this sheet again.",
    action: "Reconnect Google",
  },
  google_file_access_lost: {
    title: "Pick this file again",
    body: "This sheet is not shared with the connected Google account. Pick the file again in the Google window.",
    action: "Reconnect Google",
  },
};

export const RECONNECT_REQUIRED_MESSAGE =
  "Reconnect Google to keep editing this sheet.";

export const FILE_ACCESS_LOST_MESSAGE =
  "This Google Sheet is no longer shared with the connected account.";

export function sheetsReconnectFromAttempt(
  attempt: { errorMessage?: string | null; errorCode?: string | null } | undefined,
): SheetsReconnectInfo | null {
  if (!attempt) return null;
  if (attempt.errorCode === "google_reconnect_required") {
    return { kind: "google_reconnect_required", ...COPY.google_reconnect_required };
  }
  if (attempt.errorCode === "google_file_access_lost") {
    return { kind: "google_file_access_lost", ...COPY.google_file_access_lost };
  }
  if (attempt.errorMessage === RECONNECT_REQUIRED_MESSAGE) {
    return { kind: "google_reconnect_required", ...COPY.google_reconnect_required };
  }
  if (attempt.errorMessage === FILE_ACCESS_LOST_MESSAGE) {
    return { kind: "google_file_access_lost", ...COPY.google_file_access_lost };
  }
  return null;
}

export function sheetsReconnectFromError(error: unknown): SheetsReconnectInfo | null {
  const code = apiErrorCode(error);
  if (code !== "google_reconnect_required" && code !== "google_file_access_lost") {
    return null;
  }
  return { kind: code, ...COPY[code] };
}
